"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubcategoryItem = void 0;
var _QuestionList = require("../QuestionList/QuestionList");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubcategoryItem = (param)=>{
    let { questions, title } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.TitleWrapper, {
                children: [
                    " ",
                    title,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_QuestionList.QuestionList, {
                isShowMoreEnabled: true,
                questionList: questions
            })
        ]
    });
};
exports.SubcategoryItem = SubcategoryItem;
